export default __webpack_public_path__ + "static/media/kompjuterska-vizualizacija.1bb38fdd.gif";